<template>
    <div :style="{ backgroundImage: `url(${require('@/assets/images/loginBack.jpg')})` }"
        class="img-cover d-flex flex-wrap loginPage">

        <div class="img-content flex-fill col-lg-8 col-sm-6 d-none d-sm-flex align-items-center justify-content-center">
            <div class="sign">
                Don’t have an account?
                <router-link :to="{ name: 'signup' }">
                    Sign up here
                </router-link>
            </div>
            <div>
                <div class="title w-100 text-center">Welcome To</div>
                <div class="w-100 text-center">
                    <img src="@/assets/images/loginLogo.png" class="logo mt-4">
                </div>
                <div class="w-100 d-flex justify-content-center">
                    <div class="sub-title mt-4 col-7 p-0 text-center">
                        first fully immersive and comprehensive training
                        solution for quick service restaurant Industry
                    </div>
                </div>
            </div>
        </div>

        <div class="box col-lg-4 col-sm-6 col-12">
            <div>Thanks for choosing us,
                <br> Sign In here
            </div>

            <form @submit.prevent="submit">
                <div class="form" :class="{ error: v$.form.email.$errors.length }">
                    <input class="input w-100 mt-input" type="text" v-model="v$.form.email.$model"
                        placeholder="Email Address" autocomplete="email">

                    <div class="input-errors" v-for="(error, index) of v$.form.email.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                    </div>
                </div>
                <div class="form" :class="{ error: v$.form.password.$errors.length }">
                    <input class="input mt-3 w-100" type="password" v-model="v$.form.password.$model" placeholder="Password"
                        autocomplete="password">

                    <div class="input-errors" v-for="(error, index) of v$.form.password.$errors" :key="index">
                        <div class="error-msg">{{ error.$message }}</div>
                    </div>
                </div>

                <div class="w-100 d-flex mt-5 justify-content-center">
                    <button type="submit" class="btn">SIGN IN</button>
                </div>
            </form>

            <div class="forgot mt-3 text-center">Forgot Password? <a href="/forget-password"
                    style="text-decoration: underline">Restore from Here</a></div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

import { login } from "@/services/axios/login.service";

import store from '@/store';

import { toast } from 'vue3-toastify';

export default {
    name: 'loginPage',

    setup() {
        return { v$: useVuelidate() }
    },

    data() {
        return {
            form: {
                email: '',
                password: '',
            },

            toastConfig: {
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_LEFT,
                type: toast.TYPE.SUCCESS,
                theme: toast.THEME.COLORED
            }
        }
    },

    validations() {
        return {
            form: {
                email: { required, email },
                password: { required }
            }
        }
    },

    methods: {
        async submit() {
            this.v$.$touch();

            if (this.v$.$invalid) {
                return;
            }

            login(this.form).then(res => {
                if (!res) {
                    return;
                }
                console.log('login--login--login')

                store.commit('mutationer', { accessToken: res?.data?.data?.token });
                localStorage.setItem('accessToken', res?.data?.data?.token);

                // if (res?.data?.data?.user?.first_name) {
                store.commit('mutationer', { username: res?.data?.data?.user?.first_name || '' });
                localStorage.removeItem('username')
                localStorage.setItem('username', res?.data?.data?.user?.first_name || '');
                // }

                // if (res?.data?.data?.user?.profile) {
                store.commit('mutationer', { avatar: res?.data?.data?.user?.profile || '' });
                localStorage.removeItem('avatar')
                localStorage.setItem('avatar', res?.data?.data?.user?.profile || '');
                // }

                this.$router.push({ name: 'homePage' });

                toast(res?.data?.message, this.toastConfig);

            }).catch(e => {
                console.log('login error', e)
            })
        },

    }
}

</script>

<style lang="scss">
@import 'Auth';
</style>